import { Icon, IconChartHistogram, IconCoin, IconReportMoney, IconScale, IconZoomMoney } from '@tabler/icons-react';
import { PRO_FORMA_TABLE_NAV } from 'views/ProFormaTable/constants';

export const EXTRACTED_FROM_EXCEL_BADGE = 'Extracted from Excel';
export const NOT_LOCATED_VALUE = '—';
export const EXTRACTION_INCOMPLETE_TITLE = 'This extraction has no values to show yet.';

export const EXTRACTED_PRO_FORMA_NAV = {
    SOURCES_AND_USES: { name: 'Sources and Uses', icon: IconReportMoney },
    EXECUTIVE_SUMMARY: { name: 'Executive Summary', icon: PRO_FORMA_TABLE_NAV.EXECUTIVE_SUMMARY.icon },
} as const;

export const DEFAULT_EXTRACTED_PRO_FORMA_SECTION = EXTRACTED_PRO_FORMA_NAV.EXECUTIVE_SUMMARY.name;
export const SECTION_SEARCH_PARAM = 'section';

export const KEY_STAT_FIELDS: readonly { key: string; title: string; icon: Icon }[] = [
    { key: 'returns.levered_irr', title: 'Levered IRR', icon: IconZoomMoney },
    { key: 'returns.levered_equity_multiple', title: 'Levered EMx', icon: IconChartHistogram },
    { key: 'returns.yield_on_cost_untrended', title: 'Stabilized yield-on-cost', icon: IconScale },
    { key: 'forecast.net_sale_proceeds', title: 'Net sale proceeds', icon: IconCoin },
];

export const TIMELINE_KEYS: readonly string[] = [
    'timeline.analysis_start',
    'timeline.first_unit_delivered',
    'timeline.development_start_date',
    'timeline.development_end_date',
    'timeline.operation_start_date',
    'timeline.first_stabilized_month',
    'timeline.sale_month',
];

export const DEVELOPMENT_USES_PREFIX = 'development.uses.';
export const DEVELOPMENT_SOURCES_PREFIX = 'development.sources.';

export const SOURCE_WORKBOOK_TITLE = 'Source workbook';
export const FILE_NAME_LABEL = 'File name';
export const FILE_SIZE_LABEL = 'File size';
export const EXTRACTION_DATE_LABEL = 'Extraction date';
export const DOWNLOAD_ORIGINAL_WORKBOOK = 'Download original .xlsx';
